// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("`../../assets/cateories/right.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("`../../assets/cateories/left.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  padding: 0;
  font-family: Thicker;
}

::-webkit-scrollbar {
  width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f4f6f7;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #ba1e24;
}

.carousel-indicators {
  position: absolute !important;
  bottom: -50px !important;
}
.carousel-indicators > button {
  background-color: #ba1e24 !important;
  height: 10px !important;
  width: 10px !important;
  border-radius: 50% !important;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #ba1e24;
}
.carousel-control-next-icon {
  position: relative;
  right: -150px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.carousel-control-prev-icon {
  position: relative;
  left: -150px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.slick-dots > li {
  width: 10px;
  margin: 0 6px;

}

.slick-dots > li > button {
  display: block;
}

.slick-dots > li > button::before {
  color: #BA1E24;
  background-color: #BA1E24;
  width: 12px;
  height: 12px;
  border-radius: 50%;
}

.slick-dots li button:before {
  color: gray;
  background-color: gray; 
}

/* Optional: Change the color of the active dot */
.slick-dots li.slick-active button:before {
  color: #BA1E24; /* Change this to your desired active color */
}

.slick-dots li.slick-active button:before {
  color: #BA1E24;
  background-color: #BA1E24;
}

/* 
.slick-dots > li > button::after {
  width: 10px !important;
  height: 10px !important;
  border-radius: 50%;
  display: none !important;
} */











@media screen and (max-width: 1200px) {
  .carousel-control-next-icon {
    position: relative;
    right: -100px;
  }
  .carousel-control-prev-icon {
    position: relative;
    left: -100px;
  }
}
@media screen and (max-width: 850px) {
  .carousel-control-next-icon {
    position: relative;
    right: -80px;
  }
  .carousel-control-prev-icon {
    position: relative;
    left: -80px;
  }
}
@media screen and (max-width: 650px) {
  .carousel-control-next-icon {
    position: relative;
    right: -50px;
  }
  .carousel-control-prev-icon {
    position: relative;
    left: -50px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,UAAU;AACZ;;AAEA,UAAU;AACV;EACE,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,wBAAwB;AAC1B;AACA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,yDAAwD;AAC1D;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,yDAAuD;AACzD;;AAEA;EACE,WAAW;EACX,aAAa;;AAEf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA,iDAAiD;AACjD;EACE,cAAc,EAAE,6CAA6C;AAC/D;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;;;;;GAMG;;;;;;;;;;;;AAYH;EACE;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,YAAY;EACd;AACF;AACA;EACE;IACE,kBAAkB;IAClB,YAAY;EACd;EACA;IACE,kBAAkB;IAClB,WAAW;EACb;AACF;AACA;EACE;IACE,kBAAkB;IAClB,YAAY;EACd;EACA;IACE,kBAAkB;IAClB,WAAW;EACb;AACF","sourcesContent":["body {\n  margin: 0;\n  padding: 0;\n  font-family: Thicker;\n}\n\n::-webkit-scrollbar {\n  width: 5px;\n}\n\n/* Track */\n::-webkit-scrollbar-track {\n  background: #f4f6f7;\n}\n\n/* Handle */\n::-webkit-scrollbar-thumb {\n  background: #ba1e24;\n}\n\n.carousel-indicators {\n  position: absolute !important;\n  bottom: -50px !important;\n}\n.carousel-indicators > button {\n  background-color: #ba1e24 !important;\n  height: 10px !important;\n  width: 10px !important;\n  border-radius: 50% !important;\n}\n\n/* Handle on hover */\n::-webkit-scrollbar-thumb:hover {\n  background: #ba1e24;\n}\n.carousel-control-next-icon {\n  position: relative;\n  right: -150px;\n  background-image: url(`../../assets/cateories/right.svg);\n}\n.carousel-control-prev-icon {\n  position: relative;\n  left: -150px;\n  background-image: url(`../../assets/cateories/left.svg);\n}\n\n.slick-dots > li {\n  width: 10px;\n  margin: 0 6px;\n\n}\n\n.slick-dots > li > button {\n  display: block;\n}\n\n.slick-dots > li > button::before {\n  color: #BA1E24;\n  background-color: #BA1E24;\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n}\n\n.slick-dots li button:before {\n  color: gray;\n  background-color: gray; \n}\n\n/* Optional: Change the color of the active dot */\n.slick-dots li.slick-active button:before {\n  color: #BA1E24; /* Change this to your desired active color */\n}\n\n.slick-dots li.slick-active button:before {\n  color: #BA1E24;\n  background-color: #BA1E24;\n}\n\n/* \n.slick-dots > li > button::after {\n  width: 10px !important;\n  height: 10px !important;\n  border-radius: 50%;\n  display: none !important;\n} */\n\n\n\n\n\n\n\n\n\n\n\n@media screen and (max-width: 1200px) {\n  .carousel-control-next-icon {\n    position: relative;\n    right: -100px;\n  }\n  .carousel-control-prev-icon {\n    position: relative;\n    left: -100px;\n  }\n}\n@media screen and (max-width: 850px) {\n  .carousel-control-next-icon {\n    position: relative;\n    right: -80px;\n  }\n  .carousel-control-prev-icon {\n    position: relative;\n    left: -80px;\n  }\n}\n@media screen and (max-width: 650px) {\n  .carousel-control-next-icon {\n    position: relative;\n    right: -50px;\n  }\n  .carousel-control-prev-icon {\n    position: relative;\n    left: -50px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
